/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageUser from "./manageUsers";
import ManageUserDetail from "./manageUsers/view";
import ManageSubadmin from "./manageSubadmin";

import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageCms from "./manageCms";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import Edituser from "./manageUsers/edit";

import ManagePromotion from "./manage-promotion";
import AddPromotion from "./manage-promotion/addPromotion";
import AddNotification from "./manageNotifications/add";
import NotificationDetail from "./manageNotifications/view";
import ManageSystemSettings from "./manageSystemSettings";
import AddEmailTemplate from "./manageSystemSettings/addEmailTemplate";
import ManageStores from "./manageStores";
import AddStore from "./manageStores/add";
import StoreDetail from "./manageStores/view";
import ManageQrCode from "./manageQrCode";
import ManageRewards from "./manageRewards";
import AddRewards from "./manageRewards/add";
import RewardsDetail from "./manageRewards/view";
import ViewPromotion from "./manage-promotion/viewPromotion";
import ManageTransction from "./manage-transction";
import ViewTransction from "./manage-transction/viewTransction";
import ManageActivityLogs from "./manageActivityLogs";
import ManageFeedbackReports from "./manageFeedbackReports";
import ManageReadyMadeYoghurt from "./manage-readymade-yoghurt";
import AddReadyMadeYoghurt from "./manage-readymade-yoghurt/addReadyMadeYoghurt";
import OrderManagement from "./order-management/order-management";
import CustomerSupport from "./customer-support";
import Ratings from "./ratings";
import RevenueAnalytic from "./revenue-analytic";
import LoyaltyPoints from "./loyalty-points";
import AddLoyalty from "./loyalty-points/add";
import ManageFlavor from "./manage-flavour/page";
import ViewReadyMadeYoghurt from "./manage-readymade-yoghurt/view";
import ManageFlavorQuantity from "./manage-flavour/manage-quantity/page";
import ManageDrivers from "./manage-drivers";
import AddDriver from "./manage-drivers/add";
import ViewDriver from "./manage-drivers/view";
import ManageDispatcher from "./manage-dispatchers";
import AddDispatcher from "./manage-dispatchers/add";
import ViewOrder from "./order-management/order-management/view";
import DiscountCoupon from "./DiscountAndCoupon/discountCoupon";
import AddDiscount from "./DiscountAndCoupon/add";
import ViewDiscount from "./DiscountAndCoupon/view";
import ManageYogurtType from "./manage-yogurt-type";
import YogurtTypeDetail from "./manage-yogurt-type/manage";
import ManageBoxArt from "./manage-box-art";
import ManageGreekBox from "./manage-greek-box";
import AddGreekBox from "./manage-greek-box/add";
import ManageToppings from "./manage-toppings";
import AddTopping from "./manage-toppings/add";

import ManageProductCategories from "./manage-categories";
import ManageProducts from "./manage-products";
import ManageProductsDetail from "./manage-products/view";
import StoreInventory from "./manageStores/inventory";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageUser,
  Edituser,
  ManageUserDetail,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,

  ManageNotifications,
  AddNotification,
  NotificationDetail,
  RecievedNotifications,
  ManageCms,
  ManageProfile,
  EditProfile,
  ChangePassword,
  ManageSystemSettings,
  DiscountCoupon,
  AddDiscount,
  ViewDiscount,
  ManagePromotion,
  AddPromotion,
  AddEmailTemplate,
  ManageStores,
  AddStore,
  StoreDetail,
  ManageQrCode,
  ManageRewards,
  AddRewards,
  RewardsDetail,
  ViewPromotion,
  ManageTransction,
  ViewTransction,
  ManageActivityLogs,
  ManageFeedbackReports,
  ManageReadyMadeYoghurt,
  AddReadyMadeYoghurt,
  OrderManagement,
  ManageToppings,
  AddTopping,
  CustomerSupport,
  Ratings,
  RevenueAnalytic,
  LoyaltyPoints,
  AddLoyalty,
  ManageFlavor,
  ViewReadyMadeYoghurt,
  ManageFlavorQuantity,
  ManageDrivers,
  AddDriver,
  ViewDriver,
  ManageDispatcher,
  AddDispatcher,
  ViewOrder,

  ManageYogurtType,
  YogurtTypeDetail,
  ManageProducts,
  ManageBoxArt,
  ManageGreekBox,
  AddGreekBox,
  ManageProductCategories,
  ManageProductsDetail,
  StoreInventory,
};
